// eslint-disable-file react/no-danger

import React, { useEffect, useState } from 'react';
import { isFuture, isPast, parseISO } from 'date-fns';
import DomPurify from 'dompurify';

import { Message } from 'semantic-ui-react';
import getUserMessage from '../../api/getUserMessage';

export const messageShouldBeDisplayed = (message) => {
  const nowIsAfterStartDate = isPast(parseISO(message.startsAt));
  const nowIsBeforeEndDate = isFuture(parseISO(message.endsAt));

  return nowIsAfterStartDate && nowIsBeforeEndDate;
};

const UserMessage = () => {
  const [message, setMessage] = useState({});

  useEffect(() => {
    getUserMessage().then(setMessage);
  }, []);

  if (messageShouldBeDisplayed(message)) {
    return (
      <Message>
        <div
          /* eslint-disable-next-line react/no-danger */
          dangerouslySetInnerHTML={{ __html: DomPurify.sanitize(message.html) }}
          data-jira-id={message.jiraIssueId}
        />
      </Message>
    );
  }

  return null;
};

export default UserMessage;
